import axios from "axios";
import { setuserInfo } from "../../Reducer/DashboardReducer";
import { AppListFunction } from "./AppList/AppListFunction";
import { ViewProductFunction } from "./ViewProduct/ViewProductFunction";

export class DashboardFunction {
  async logout(setLoading, setToastConfig, toastConfig) {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/user/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((val) => {
        if (val?.data?.success) {
          localStorage.clear();
          window.location.reload();
        }
      })
      .catch((err) => {
        setLoading(false);
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        } else {
        }
      });
  }
  async getUserDetail(setLoading, dispatch, setToastConfig, toastConfig) {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/user/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          const { id, } = val?.data?.result;
          localStorage.setItem("userID", id);
          dispatch(setuserInfo(val?.data?.result));
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }

        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }

  async imageUpload(
    setLoading,
    body,
    body2,
    setToastConfig,
    toastConfig,
    setcraeteAppShow,
    GetProduct,
    viewData,
    type,
    setDAta,
    navigate,
    dispatch
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/v1/common/upload`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          let clas = new AppListFunction();
          let clas2 = new ViewProductFunction();
          if (type === 0) {
            clas.CretaeProduct(
              setLoading,
              { ...body2, app_logo: val?.data?.result?.url },
              setToastConfig,
              toastConfig,
              setcraeteAppShow,
              GetProduct,
              navigate,
              dispatch
            );
          } else {
            clas2.UpdateProduct(
              setLoading,
              { ...body2, app_logo: val?.data?.result?.url },
              setToastConfig,
              toastConfig,
              setcraeteAppShow,
              viewData,
              setDAta,
              dispatch
            );
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }

        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }
}
